export const initialEntitiesState = {
    entitiesByProjectIdByEntityId: {},
    entityIdsByProjectId: {},
    entityClassesByProjectIdByEntityClassId: {},
    entityClassIdsByProjectId: {},
};
